module.exports = __webpack_public_path__ + "static/img/sign.c3309ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Hridya/Hridya-pics/sign.jpg
// module id = mfZc
// module chunks = 0